
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/India-store",
      function () {
        return require("private-next-pages/explore/India-store.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/India-store"])
      });
    }
  